import React, { Suspense } from 'react'
import { RouteComponentProps } from 'react-router-dom'

type Props = RouteComponentProps<{ id: string }>

const ImagePreviewPage = React.lazy(() => import('.'))

export default ({ match }: Props) => (
  <Suspense fallback={<div />}>
    <ImagePreviewPage match={match} />
  </Suspense>
)
